import api from '../../plugins/api';

const startAppRefresh = () => {
  return api.post('/api/crm/reports/app-refresh');
};

export default startAppRefresh;
